import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import * as Styled from './SubtleButton.styled';

const SubtleButton = (props) => {
  const {
    classes,
    className,
    isDisabled,
    children,
    variant,
    ...passThroughProps
  } = props;

  return (
    <Styled.SubtleButtonComponent
      className={classnames(className, classes.root)}
      disabled={isDisabled}
      variant={variant}
      {...passThroughProps}>
      {children}
    </Styled.SubtleButtonComponent>
  );
};

SubtleButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({
    root: PropTypes.string,
  }),
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(['primary']),
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};

SubtleButton.defaultProps = {
  className: '',
  classes: {
    root: '',
  },
  isDisabled: false,
  children: null,
  variant: 'primary',
};

export default SubtleButton;
